import * as PIXI from 'pixi.js'
import SheepBubble from './sheep-bubble.js'
import Vec2 from './vec2.js'

class Platform {
  constructor (game, type, speed) {
    this.game = game
    this.speed = speed || 2

    this.textures = {
      cool1: PIXI.Texture.from('cool1'),
      cool2: PIXI.Texture.from('cool2'),
      foam1: PIXI.Texture.from('foam1'),
      foam2: PIXI.Texture.from('foam2'),
      spring1: PIXI.Texture.from('spring1'),
      spring2: PIXI.Texture.from('spring2'),
      sheep1: PIXI.Texture.from('sheep1'),
      sheep2: PIXI.Texture.from('sheep2'),
      sheep3: PIXI.Texture.from('sheep3'),
    }

    this.type = type || 'cool'
    this.transformTo(this.type, 0.2)

    // 給 bubble 用的控制變數
    this.controls = {
      ay: -0.065, // -2 ~ 2
      fade: 0.96, // 0 ~ 1
      v: 10 // 0 ~ 50, step 0.1
    }
  }

  transformTo (type, animationSpeed = 0.2) {
    this.type = type
    this.setTextures([
      this.textures[`${type}1`],
      this.textures[`${type}2`]
    ])
    this.view.animationSpeed = animationSpeed || 0.2

    if (this.type === 'sheep') {
      this.view.animationSpeed = 0.1
      this.direction = Math.random() > 0.5 ? 'right' : 'left'
      this.view.scale.x *= this.direction === 'right' ? -1 : 1
      this.view.loop = true
      this.view.play()
    }
  }

  speedUpTo (speed = 2) {
    this.speed = speed
  }

  setTextures (sprites) {
    if (this.view) {
      this.view.textures = sprites
    } else {
      this.view = new PIXI.extras.AnimatedSprite(sprites)
    }
    this.view.scale.set(0.25)
    this.view.anchor.set(0.5, 0.5)
  }

  draw () {
    this.game.app.stage.addChildAt(this.view, 1)
  }

  quake () {
    if (this.type === 'sheep') {
      this.setTextures([
        this.textures.sheep3
      ])
    }

    this.view.scale.x *= this.direction === 'right' ? -1 : 1
    this.view.loop = false
    this.view.play()
  }

  setPosition (x, y) {
    this.view.x = x
    this.view.y = y
  }

  moveDown (cameraDelta = 0, entitySpeed = 1, deltaTime = 1) {
    this.view.y += ((this.speed + cameraDelta) * entitySpeed * deltaTime)
  }

  generateBubbles (n = 3) {
    const bubbles = []
    const v = this.controls.v

    for (var i = 0; i < n; i++) {
      const bubble = new SheepBubble(this.game, {
        p: new Vec2(this.view.x, this.view.y + 75),
        v: new Vec2(Math.random() * v - v / 2, Math.random() * v - v / 2),
        r: Math.random(),
        controls: this.controls
      })
      bubble.draw()
      bubbles.push(bubble)
    }

    return bubbles
  }

  destroy () {
    this.game.app.stage.removeChild(this.view)
    this.view.destroy()
  }
}

export default Platform
